import { render, staticRenderFns } from "./benefits-tier-panel.vue?vue&type=template&id=70008e65&scoped=true"
import script from "./benefits-tier-panel.vue?vue&type=script&lang=js"
export * from "./benefits-tier-panel.vue?vue&type=script&lang=js"
import style0 from "./benefits-tier-panel.vue?vue&type=style&index=0&id=70008e65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70008e65",
  null
  
)

export default component.exports